import hatsApi from '@/services/hatsApi'

export default {
  getCurrencies (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/currency/?filter=' + filter)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Currency.js